const fixedNumber = (num, digits = 2, base = 10) => {
  const factor = base ** digits;
  return Math.round(Number(num) * factor) / factor;
};

export default fixedNumber;
